function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var register = {
  parts: ["container", "preview", "input"]
};
var previewStyle = {
  borderRadius: "md",
  paddingY: "3px",
  transition: "all 0.2s"
};
var baseStyle = {
  container: {},
  preview: previewStyle,
  input: _extends({}, previewStyle, {
    width: "full",
    _focus: {
      boxShadow: "outline"
    },
    _placeholder: {
      opacity: 0.6
    }
  })
};
var editable = {
  register,
  baseStyle
};
export default editable;
//# sourceMappingURL=editable.js.map